import { render, staticRenderFns } from "./ResourceInstanceView.vue?vue&type=template&id=5997c2ca&"
import script from "./ResourceInstanceView.vue?vue&type=script&lang=js&"
export * from "./ResourceInstanceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports